import React, { useEffect, useMemo, useState, useCallback } from "react";
import RdvAffaireImmo from "../../components/RdvAffaireImmo";
import CardRdv from "../../components/CardRdv";

function TabsAffaireRdv(args) {
  const { affaire } = args;
  const affaireId = affaire?.id;

  const [rdvRecords, setRdvRecords] = useState([]);
  const [demandeRdv, setDemandeRdv] = useState([]);

  const airtableHeaders = {
    Authorization:
      "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
    Accept: "application/json",
  };

  const getRdv = useCallback(async () => {
    if (!affaireId) return;

    const URL = `https://api.airtable.com/v0/appD48APNaGA4GN0B/rdv?filterByFormula=SEARCH("${affaireId}",{transaction})`;

    try {
      const res = await fetch(URL, { method: "GET", headers: airtableHeaders });

      if (!res.ok) {
        console.error("getRdv HTTP", res.status, await res.text());
        return;
      }

      const data = await res.json();
      const records = data.records ?? [];

      const sorted = [...records].sort((a, b) =>
        (a.fields?.sort ?? 999) < (b.fields?.sort ?? 999) ? -1 : 1
      );

      setRdvRecords(sorted);
    } catch (e) {
      console.error("getRdv error", e);
    }
  }, [affaireId]);

  const getDemandeRdv = useCallback(async () => {
    if (!affaireId) return;

    const URL = `https://api.airtable.com/v0/appD48APNaGA4GN0B/demande_rdv?filterByFormula=SEARCH("${affaireId}",{id_affaire})`;

    try {
      const res = await fetch(URL, { method: "GET", headers: airtableHeaders });

      if (!res.ok) {
        console.error("getDemandeRdv HTTP", res.status, await res.text());
        return;
      }

      const data = await res.json();
      const records = data.records ?? [];

      const sorted = [...records].sort((a, b) =>
        (a.fields?.sort ?? 999) < (b.fields?.sort ?? 999) ? -1 : 1
      );

      setDemandeRdv(sorted);
    } catch (e) {
      console.error("getDemandeRdv error", e);
    }
  }, [affaireId]);

  useEffect(() => {
    if (!affaireId) return;
    getRdv();
    getDemandeRdv();
  }, [affaireId, getRdv, getDemandeRdv]);

  const rdvNotaire = useMemo(
    () => rdvRecords.find((r) => r.fields?.nom === "Rendez-vous notaire") ?? null,
    [rdvRecords]
  );

  const rdvCompromis = useMemo(
    () =>
      rdvRecords.find((r) => r.fields?.nom === "Signature - Compromis de vente") ??
      null,
    [rdvRecords]
  );

  const rdvActe = useMemo(
    () =>
      rdvRecords.find(
        (r) => r.fields?.nom === "Signature - Acte authentique de vente"
      ) ?? null,
    [rdvRecords]
  );

  return (
    <div>
      <RdvAffaireImmo
        type="immo"
        idAffaire={affaireId}
        notaireAirtableId={affaire?.notaire?.[0] ?? null}
        rdvNotaire={rdvNotaire}
        rdvCompromis={rdvCompromis}
        rdvActe={rdvActe}
        refreshData={getRdv}
      />

      {demandeRdv.length > 0 && (
        <CardRdv
          date_creation={demandeRdv[0].fields?.date_creation}
          date={demandeRdv[0].fields?.date}
          heure_debut={demandeRdv[0].fields?.heure_debut}
          heure_fin={demandeRdv[0].fields?.heure_fin}
          type_rdv={demandeRdv[0].fields?.type}
          statut={demandeRdv[0].fields?.statut}
          id={demandeRdv[0].id}
        />
      )}
    </div>
  );
}

export default TabsAffaireRdv;